/**
 * /auth/callback — landing page after Entra ID returns from sign-in.
 *
 * The actual token exchange is handled in main.tsx via
 * msalInstance.handleRedirectPromise() BEFORE this component mounts. Once
 * the active account is set, MSAL fires LOGIN_SUCCESS, which our Login
 * page reacts to by navigating to ?redirect=... or /tickets.
 *
 * If we land here without a pending redirect (e.g. user manually hits the
 * URL), the protected loader will bounce them back to /login.
 */
export function AuthCallback() {
  return (
    <div className="min-h-screen grid place-items-center text-muted-foreground">
      <div className="flex items-center gap-3">
        <span className="inline-block w-4 h-4 rounded-full border-2 border-primary border-r-transparent animate-spin" />
        Completing sign-in…
      </div>
    </div>
  );
}
